export { apiConfig } from './api';
export { wsConfig } from './ws';

export const appConfig = {
  apiConfig: {
    apiHost: import.meta.env.VITE_API_URL,
    authHost: import.meta.env.VITE_AUTH_API_URL,
    tristarGamesHost: import.meta.env.VITE_TRISTAR_GAMES_URL,
  },
  wsConfig: {
    wsHost: import.meta.env.VITE_WS_URL,
  },
};
